import { useState } from "react";
import { Pie, PieChart, ResponsiveContainer, Sector } from "recharts";
import styled, { useTheme } from "styled-components";
import { formatAmountWithDecimals } from "../../lib/utils";
import { Paragraph } from "../styled";

const renderActiveShape = (props, tokenSymbol) => {
	const RADIAN = Math.PI / 180;
	const {
		cx,
		cy,
		midAngle,
		innerRadius,
		outerRadius,
		startAngle,
		endAngle,
		payload,
		percent,
		value,
	} = props;
	const sin = Math.sin(-RADIAN * midAngle);
	const cos = Math.cos(-RADIAN * midAngle);
	const sx = cx + (outerRadius + 10) * cos;
	const sy = cy + (outerRadius + 10) * sin;
	const mx = cx + (outerRadius + 30) * cos;
	const my = cy + (outerRadius + 30) * sin;
	const ex = mx + (cos >= 0 ? 1 : -1) * 22;
	const ey = my;
	const textAnchor = cos >= 0 ? "start" : "end";

	return (
		<g>
			{/* <Text x={cx} y={cy} dy={0} textAnchor="middle" width={40} height={100} textLength={100}> */}
			{/*  {payload.name} */}
			{/* </Text> */}
			<foreignObject x={cx - 35} y={cy - 35} dy={-70} width="70" height="70">
				<CenterTextWrapper>
					<CenterText>{payload.name}</CenterText>
				</CenterTextWrapper>
			</foreignObject>
			<Sector
				cx={cx}
				cy={cy}
				innerRadius={innerRadius}
				outerRadius={outerRadius}
				startAngle={startAngle}
				endAngle={endAngle}
				fill="#4AB0A6"
			/>
			<Sector
				cx={cx}
				cy={cy}
				startAngle={startAngle}
				endAngle={endAngle}
				innerRadius={outerRadius + 6}
				outerRadius={outerRadius + 10}
				fill="#4AB0A6"
			/>
			<path
				d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
				stroke="#4AB0A6"
				fill="none"
			/>
			<circle cx={ex} cy={ey} r={2} fill="#4AB0A6" stroke="none" />
			<text
				x={ex + (cos >= 0 ? 1 : -1) * 12}
				y={ey + 8}
				textAnchor={textAnchor}
				fill="#4AB0A6"
				style={{
					fontSize: 12,
					fontFamily: "ProximaNovaBold",
				}}
			>
				{`${formatAmountWithDecimals(value, 2)}`}
				{tokenSymbol}
			</text>
			{/* Use 2 as default decimal value */}
			<text
				x={ex + (cos >= 0 ? 1 : -1) * 12}
				y={ey + 5}
				dy={18}
				textAnchor={textAnchor}
				fill="white"
				style={{
					fontSize: 12,
					fontFamily: "ProximaNovaBold",
				}}
			>
				{`${(percent * 100).toFixed(2)}%`}
			</text>
		</g>
	);
};

// TODO: Determine how to use `dataKey` with TypeScript instead of having a separate `valueGetter` function

export const CustomPieChart = <T extends object>({
	data,
	tokenSymbol,
}: { data: T[]; tokenSymbol?: string }) => {
	const theme = useTheme();
	const [activeIndex, setActiveIndex] = useState<number>(0);
	const { grey } = theme.colors.secondary;
	const _colors = [
		theme.colors.secondary.yellow,
		theme.colors.secondary.lightgreen,
		theme.colors.primary.green,
		theme.colors.secondary.blue,
		theme.colors.secondary.darkgreen,
	];

	const onPieEnter = (_, index) => {
		setActiveIndex(index);
	};
	return (
		<ResponsiveContainer width="100%" height="100%">
			<PieChart width={70} height={70}>
				<Pie
					activeIndex={activeIndex}
					activeShape={(props) => renderActiveShape(props, tokenSymbol)}
					data={data}
					cx="50%"
					cy="50%"
					innerRadius={45}
					outerRadius={60}
					fill={grey}
					dataKey="value"
					onMouseEnter={onPieEnter}
				/>
			</PieChart>
		</ResponsiveContainer>
	);
};

const CenterTextWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 0;
`;

const CenterText = styled(Paragraph)`
  width: 60px;
  text-align: center;
`;
